/**
 * Form helper
 */
import $ from "jquery";
import _ from "underscore";

export function getFormData(form, allowEmpty = false) {
  const query = {};

  _.each($(form).serializeArray(), (f) => {
    if (
      "id" === f.name &&
      f.value.length > 2 &&
      isNaN(Number(f.value.substr(0, 2)))
    ) {
      f.value = f.value.substr(2);
    }

    // If value is empty, and empty not allowed; skip
    if (_.isEmpty(f.value) && !allowEmpty) {
      return;
    }

    // If field name already string; convert to array
    if ("string" === typeof query[f.name]) {
      query[f.name] = [query[f.name]];
    }

    if (query[f.name] instanceof Array) {
      query[f.name].push(f.value);
    } else {
      query[f.name] = f.value;
    }
  });

  return query;
}

export function putFormData(form, data, trigger = false) {
  const fields = [];
  const maxDepth = 10;
  const process = function (data, parentField, currentField, depth) {
    parentField = parentField || "";
    currentField = currentField || "";
    depth = depth || 0;

    // If maxDepth exceeded, return
    if (depth > maxDepth) {
      return;
    }

    // If data is array
    if (data instanceof Array) {
      for (let i = data.length - 1; i >= 0; i--) {
        process(data[i], parentField, currentField, depth + 1);
      }
    }
    // Else if data is object
    else if (data instanceof Object) {
      // Set current field to parent field
      parentField = parentField
        ? parentField + "[" + currentField + "]"
        : currentField;
      // Loop through fields in data
      let field;
      for (field in data) {
        // Recursively process data
        process(data[field], parentField, field, depth + 1);
      }
    }
    // Else data is value
    else {
      // Push data
      fields.push({
        name: parentField
          ? parentField + "[" + currentField + "]"
          : currentField,
        value: data,
      });
    }
  };

  process(data);

  let inputs;

  form = $(form);
  for (let i = fields.length - 1; i >= 0; i--) {
    inputs = form.find('[name="' + fields[i].name + '"]');
    if (inputs.length) {
      _setFieldValue(inputs, fields[i].value, trigger);
    }
  }

  if (trigger) {
    form.trigger("change");
  }
}

function _setFieldValue(inputs, v, trigger = false) {
  if ("undefined" !== typeof v) {
    if (null !== v) {
      if ("radio" === inputs.prop("type")) {
        inputs.filter('[value="' + v + '"]').prop("checked", true);
      } else if ("checkbox" === inputs.prop("type")) {
        inputs
          .filter(
            '[value="' + (typeof v === "boolean" ? (v ? 1 : 0) : v) + '"]',
          )
          .prop("checked", true);
      } else {
        inputs.val(v);
      }
    }

    // Trigger "change" event on element
    if (trigger) {
      inputs.trigger("change");
    }
  }
}
